import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { userApi } from '../userApi';
import { type GetUsersRequest, type GetUsersResponse } from '../types';
import { PaginateType } from '@shared/types';

export const useGetUsers = (
  params?: GetUsersRequest,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: [QueryKey.GET_USERS, params],
    queryFn: () =>
      userApi.getUsers<GetUsersResponse>({
        ...params,
        filter: params?.filter || {},
        paginate: PaginateType.NONE,
      }),
    retry: false,
    enabled,
  });
};
